import React, { useState }  from 'react';
import TogglerBody from '../TogglerBody';
import FlagCustomisationItem from './FlagCustomisationItem';
import FlagCustomisationItemToggler from './FlagCustomisationItemToggler';
import CounterTemplate from '../status/statusBlock/CounterTemplate';
import TipsTamplate from '../TipsTamplate';
import ChooseActionTamplate from '../actionTamplate/ChooseActionTamplate';
import './flagCustomisation.scss'
import { statusActionsAdvanced } from '../../../constants/common'

    const flagItemArr = [
        {
            title:'Username',
            target:'Target profiles with username that match local dictionary',
            tipsTitle:'Username',
            label:'Unsafe',
            text:'<p>Username option allows you to specify forbidden usernames. Themis will respond to these usernames with subsequent punishments as defined.</p>',
            textSecond: '',
            trigger: 'usernameTrigger',
            punishment: 'usernamePunishment',
        },
        {
            title:'Advertisement',
            target:'Target ads profiles',
            tipsTitle:'Advertisement',
            label:'Safe',
            text:'<p>Advertisement Names option enables Themis to detect and punish users with usernames containing advertisements.</p>',
            textSecond: '',
            trigger: 'advertisementTrigger',
            punishment: 'advertisementPunishment',
        },
        {
            title:'No Avatar',
            target:'Target profiles without avatar',
            tipsTitle:'No Avatar',
            label:'Unsafe',
            text:'<p>No Avatar option grants Themis the ability to take actions against users without avatars/profile pictures.</p>',
            textSecond: '',
            trigger: 'noAvatarTrigger',
            punishment: 'noAvatarPunishment',
        },
        {
            title:'Cross-Server detection',
            target:'Target suspicious account',
            tipsTitle:'Cross-Server detection',
            label:'Safe',
            text:'<p>Cross-Server Detection feature empowers Themis to utilise data from other servers in order to take actions against users who violate rules.</p>',
            textSecond: '',
            trigger: 'crossServerTrigger',
            punishment: 'crossServerPunishment',
        },
    ]


const FlagCustomisationVerification = ({title, text, data}) => {
    const [isCustommisation , setIsCustommisation] = useState(data?.enabled);
    const [isAccountAgeTrigger, setIsAccountAgeTrigger] = useState(data?.accountAgeTrigger)
    const [currentAction, setCurrentAction] = useState(data && data?.minimumAgePunishment ? data?.minimumAgePunishment : 'Kick')

    return (
        <div className='advance_seting_with_title_wrap'>
            {!!title && 
                <div className='overview_component_content_head'>
                        <h4>{title}</h4>
                        <p>{text}</p>
                </div>
            }
        <div className='status_block_wrap flag_customisation_wrap'>
            <div className='status_block_wrap_bg'></div>
            <img  className='status_block_wrap_img' src="/img/FlagSettings.svg" alt="" />
            <h3>Flag Customisation</h3>
            <div 
            className='status_block_item'
            style={{borderBottom:'1px solid #8D99A3'}}
            >
                <div className='status_block_item_toggler'>
                    <TogglerBody
                    isOn={isCustommisation}
                    setIsOn={setIsCustommisation}
                    keyName={"enabled"}
                    advance/>
                    <p>Use advanced parameters</p>
                </div>
            </div>
            <div className='status_block_item flag_customisation_wrap_block_plug'>
                <div className={`status_block_item flag_customisation_wrap_block_verif flag_customisation_wrap_block ${isCustommisation ? '' : 'flag_customisation_wrap_block_blur'}`}>
                    <div className='flag_customisation_wrap_block_item'>
                        {flagItemArr.map((item, idx) => (
                            <FlagCustomisationItemToggler
                                key={idx}
                                item={item}
                                target={item.target}
                                data={data}
                                />
                        ))}
                    </div>
                    <div className='flag_customisation_wrap_block_item_counter'>
                    <div className='flag_customisation_item_wrap flag_customisation_item_wrap_toggler'>
                            <div className='white_list_block_item_title_block flag_customisation_item_wrap_title'>
                            <h4>Account Age</h4>
                            <TipsTamplate
                                title={'Account Age'}
                                label={'Unsafe'}
                                text={'<p>Account Age option empowers Themis to punish users with accounts younger than the specified duration</p>'}
                                textSecond={''}
                                />
                            </div>
                            <p>Status</p>
                            <div className='status_block_item_toggler'>
                                <TogglerBody
                                isOn={isAccountAgeTrigger}
                                setIsOn={setIsAccountAgeTrigger} keyName='accountAgeTrigger' advance/>
                                <p>Target profiles with a certain creation date</p>
                            </div>
                            <p>Minimum Age</p>
                                <CounterTemplate
                                    data={{ data: data }}
                                    keyName='minimumAge'
                                    keyTime='minimumAgePer'
                                    valueTitle={''}
                                    timeType={'day'}
                                    advance
                                />
                            <p>Punishment</p>
                                <ChooseActionTamplate
                                keyName={'minimumAgePunishment'}
                                currentAction={currentAction}
                                setCurrentAction={setCurrentAction}
                                actionArr={statusActionsAdvanced}
                                advance
                            />
                        </div>

                    </div>
                </div>
                {!isCustommisation &&
                <div className='flag_customisation_wrap_plug'>
                        <p>Enable Advanced Parameters 🙏🏻</p>
                </div>
                }
            </div>
        </div>
        </div>
    );
};

export default FlagCustomisationVerification;